import _ from 'underscore';
/**
 * Serializes node as its value.
 * @param {Object} node
 * @returns {*}
 */
function simpleSerializer(node) {
    return node.value;
}

/**
 * Serializer for typelist values.
 * @param {Array} node
 * @returns {*}
 */
function typelistSerializer(node) {
    var value = node.value;
    if (_.isString(value)) {
        console.warn('Serializing string as a typelist value. Typecodes should be used instead.');
        return value;
    }
    return value.code;
}

/**
 * Serializer for the array values.
 * @param {Array} node
 * @returns {Array}
 */
function arraySerializer(node) {
    var len = node.length;
    var res = [];
    for (var i = 0; i < len; i++) {
        res.push(node.getElement(i).aspects.serializedForm);
    }
    return res;
}

/**
 * Serializes a DTO using given properties.
 * @param {Array} propNames
 * @param {Object} node
 * @returns {Object}
 */
function dtoSerializer(propNames, node) {
    var res = {};
    propNames.forEach(function (propName) {
        var propVal = node[propName].aspects.serializedForm;
        if (!_.isUndefined(propVal)) {
            res[propName] = propVal;
        }
    });
    return res;
}

/** Finds a value serializer based on the step metadata. Serializer takes an object node and returns its
 * serialized form.
 *
 * @param {Object} metadata
 *
 * @returns {Function}
 */
function getSerializer(metadata) {
    var type = metadata.valueType;

    switch (type.kind) {
        case 'primitive':
            return simpleSerializer;
        case 'collection':
            return arraySerializer;
        case 'stringMap':
            if (type.valueType.kind === 'primitive') {
                // console.log('Using fallback for the map value on the view model');
                return simpleSerializer;
            }
            throw new Error('Maps are not supported on the view model');
        case 'class':
            switch (type.typeInfo.metaType.kind) {
                case 'typelist':
                    return typelistSerializer;
                case 'dto':
                    return _.partial(dtoSerializer, type.typeInfo.properties.map(function (property) {
                        return property.jsProperty;
                    }));
                default:
                    throw new Error('Unsupported class type kind ' + type.typeInfo.metaType.kind);
            }
        default:
            throw new Error('Unsupported kind of the view model node : ' + type.kind);
    }
}

/** Model cleanup and optimization module. Removes non-visible and read-only arguments. Converts model values into
 * its serialized form.
 */
export default {
    'getAspectProperties': function getAspectProperties(currentViewModelNode, currentMetadataNode /* , ancestorChain*/) {
        var serializer = getSerializer(currentMetadataNode);

        return {
            'serializedForm': {
                'get': function get() {
                    if (!currentViewModelNode.aspects.visible) {
                        return;
                    }
                    var value = currentViewModelNode.value;
                    if (_.isUndefined(value) || _.isNull(value)) {
                        return value;
                    }
                    return serializer(currentViewModelNode);
                }
            }
        };
    }
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-viewmodel-js/aspects/SerializedForm.js
// module id = 941
// module chunks = 0